import { SubscriptionLockKeysEnum } from 'types/subscriptions.types';

const TaxTypeToLockMap = {
  'be/social-contribution-subject':
    SubscriptionLockKeysEnum.paySocialContribution,
  'be/social-contribution-exonerated':
    SubscriptionLockKeysEnum.paySocialContribution,
  'be/income-tax-prepayment': SubscriptionLockKeysEnum.payIncomeTaxPrePayment,
  'be/income-tax-payment': SubscriptionLockKeysEnum.payIncomeTax,
  'be/client-listing': SubscriptionLockKeysEnum.submitClientList,
  'be/vat': SubscriptionLockKeysEnum.submitVAT,
  'be/vat/submission': SubscriptionLockKeysEnum.submitVAT,
  'be/vat/payment': SubscriptionLockKeysEnum.payVAT,
  'be/special-vat': SubscriptionLockKeysEnum.submitSpecialVAT,
  'be/intracom-listing': SubscriptionLockKeysEnum.submitIntracomListing,
  'be/income-tax-submission': SubscriptionLockKeysEnum.submitIncomeTax,
  'be/company-tax-prepayment':
    SubscriptionLockKeysEnum.payCorporateTaxPrePayment,
  'be/company-tax-payment': SubscriptionLockKeysEnum.payCorporateTax,
  'be/vat-franchisee': SubscriptionLockKeysEnum.payVATThreshold,
  'de/est-payment': SubscriptionLockKeysEnum.payIncomeTax,
  'de/est-prepayment': SubscriptionLockKeysEnum.payIncomeTaxPrePayment,
  'de/uste-submission': SubscriptionLockKeysEnum.submitUSTE,
  'de/est-submission': SubscriptionLockKeysEnum.submitIncomeTax,
  'de/vat-franchisee': SubscriptionLockKeysEnum.payVATThreshold,
  'de/ustva/payment': SubscriptionLockKeysEnum.payVAT,
  'de/ustva/submission': SubscriptionLockKeysEnum.submitVAT,
  'de/ustva': SubscriptionLockKeysEnum.submitVAT,
  'de/zm': SubscriptionLockKeysEnum.submitIntracomListing,
  'de/eur': SubscriptionLockKeysEnum.submitEUR,
  'de/gewst-submission': SubscriptionLockKeysEnum.submitTradeTax,
  'de/gewst-prepayment': SubscriptionLockKeysEnum.payTradeTaxPrePayment,
};

const getTaxSlugFromPathname = (pathname: string) => {
  const pathParts = pathname.split('/').filter(Boolean);

  const taxesIndex = pathParts.indexOf('taxes');

  return taxesIndex >= 0 && pathParts.length > taxesIndex + 2
    ? pathParts.slice(taxesIndex + 1, -1).join('/')
    : '';
};

const getNormalizedTaxSlugForTranslations = (taxSlug: string) => {
  const taxSlugWithoutCountry = taxSlug.includes('/')
    ? taxSlug.split('/').slice(1).join('/')
    : taxSlug;

  return taxSlugWithoutCountry.replace(/\//g, '_').replace(/-/g, '_');
};

export {
  TaxTypeToLockMap,
  getTaxSlugFromPathname,
  getNormalizedTaxSlugForTranslations,
};
